import cn from 'classnames';
import IconCheckMarkCircle from '@/assets/icons/icon-checkmark-circle.svg';
import styles from './notificationMessage.module.scss';

const { messageWrapper, messageTextStyles, successStyles } = styles;

interface NotificationMessageProps {
    message: string;
    success: boolean;
}

export default function NotificationMessage({ message, success }: NotificationMessageProps) {
    const mainWrapperStyles = cn(messageWrapper, {
        [successStyles]: success,
    });

    return (
        <div className={mainWrapperStyles} role="status" aria-live="polite" aria-atomic="true">
            <IconCheckMarkCircle />
            <div className={messageTextStyles}>{message}</div>
        </div>
    );
}
